(function ($) {

    var priceBreakdownInit = function () {
        $('.js-price-breakdown').on('mouseenter', function (event) {
            var el = event.currentTarget;
            var $clone = $(el).parent().find('.price-breakdown').clone();
            var $cloned = $clone.appendTo('body');

            el.style.cursor = 'default';

            $(el).on('mousemove', function (event) {
                var mse = {
                    x: event.originalEvent.pageX,
                    y: event.originalEvent.pageY
                }

                $cloned.css({
                    position: 'absolute',
                    top: mse.y + 15,
                    left: mse.x
                }).fadeIn(200);
            });

            $(el).one('mouseleave', function () {
                el.style.cursor = '';
                if ($cloned && $cloned.length) {
                    $(el).off('mousemove');
                    $cloned.fadeOut('fast', () => $cloned.remove());
                }
            });
        });
    }

    if (window.PriceBreakdownInit === undefined) {
        window.PriceBreakdownInit = priceBreakdownInit;
    }
    window.PriceBreakdownInit();
    
})(jQuery);